/**
 * WVB — Search by Radio: Open by default on mobile
 * File: assets/wvb-home-filter-open.js
 * Project: Waveband Communications — Homepage Redesign Phase 1 (Rev 3)
 * Built: 08-09-2026
 *
 * The home-filter section collapses at ≤860px via .active class toggle.
 * This script adds .active on page load for mobile/tablet so it's open by default.
 * HOW TO ADD:
 * 1. Upload this file to assets/
 * 2. In layout/theme.liquid, add before </body>:
 *    <script src="{{ 'wvb-home-filter-open.js' | asset_url }}" defer></script>
 */
(function () {
  'use strict';

  var MOBILE_MAX = 860;

  function openFilterOnMobile() {
    if (window.innerWidth <= MOBILE_MAX) {
      var block = document.querySelector('.search_by_block');
      if (block && !block.classList.contains('active')) {
        block.classList.add('active');
      }
    }
  }

  // Run immediately after DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openFilterOnMobile);
  } else {
    openFilterOnMobile();
  }

  // Re-run on resize (e.g. rotating device)
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(openFilterOnMobile, 150);
  });

  // Re-run after theme editor section reload
  document.addEventListener('shopify:section:load', openFilterOnMobile);
})();